import styled from '@emotion/styled'

export const ProfilePicture = styled.div<{
  pictureLink: string
}>`
  display: inline-block;
  width: 48px;
  height: 48px;
  border-radius: 50%;

  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-image: url(${({ pictureLink }) => pictureLink});
  margin-right: 1rem;
`

export const PersonName = styled.p`
  font-weight: bold;
  color: rgba(23, 29, 34, 0.87);
  font-size: 1rem;
  margin: 0;
`

export const PersonFunction = styled.p`
  color: rgba(23, 29, 34, 0.6);
  font-size: 1rem;
  margin: 0;
`
